module.exports = __webpack_public_path__ + "img/creativity.1ca21a2a.svg";